import { render } from "./WorkerAvatar.vue?vue&type=template&id=7d2bc8ec&ts=true"
import script from "./WorkerAvatar.vue?vue&type=script&lang=ts"
export * from "./WorkerAvatar.vue?vue&type=script&lang=ts"

import "./WorkerAvatar.vue?vue&type=style&index=0&id=7d2bc8ec&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__